<page-headline
    [linkTitle]="pageHeadline.linkTitle"
    [module]="pageHeadline.module"
    [moduleIcon]="pageHeadline.moduleIcon"
    [moduleLink]="pageHeadline.moduleLink"
    [pageTitle]="pageHeadline.pageTitle"
>
</page-headline>
<div>
    <div class="menu-area layout-padding-bottom__1rem">
        <div class="ddl-area">
            <angular2-multiselect
                [data]="partnerList"
                [(ngModel)]="selectedpartner"
                [settings]="partnerListSettings"
                (onSelect)="onSelectionChange($event.value)"
                (onDeSelect)="onItemDeSelect($event)"
            >
            </angular2-multiselect>
        </div>
        <div class="displayopt-layout">
            <display-options
                (displayOptionsOutput)="applyDisplayOptions($event)"
                [showCompareToDate]="false"
            >
            </display-options>
            <action-panel [showExportCsv]="false" [showSaveAsPdf]="true" [showPrint]="false">
            </action-panel>
        </div>
    </div>
    <div
        *ngIf="selectedpartner && selectedpartner.length > 0; then ShowData; else NoDataScreen"
    ></div>
    <ng-template #ShowData>
        <div class="row-layout-track">
            <scorecards-score-summary-card
                [rankData]="detailsCard"
                class="largecard-layout-box__50"
            ></scorecards-score-summary-card>
            <scorecards-funded-production-card
                class="largecard-layout-box__50"
                [largeCardInteriorOptions]="largeCardInteriorOptions"
            >
            </scorecards-funded-production-card>
            <div class="largecard-layout-box__50">
                <card-list *ngIf="kpiCardData" [cardListData]="kpiCardData"></card-list>
            </div>
            <div class="largecard-layout-box__50">
                <scorecards-product-purpose-mix-card
                    [pieChartsData]="productionPurposeMixPieChartData"
                    [pageId]="pageId"
                ></scorecards-product-purpose-mix-card>
            </div>
        </div>
    </ng-template>
    <ng-template #NoDataScreen>
        <no-data-screen
            [noDataType]="noDataType"
            class="largecard-layout-box__100"
        ></no-data-screen>
    </ng-template>
</div>
